import { reactive } from "vue";
import { io } from "socket.io-client";

export const state = reactive({
    connected: false,
    fooEvents: [],
    barEvents: []
});

export const socket = io(import.meta.env.VITE_FEED_SOCKET_URL, {
    transports: ['websocket', 'polling'],
    secure: true,
    auth: {
        token: localStorage.getItem('token')
    },
    autoConnect: false,
});

socket.on("connect", () => {
    state.connected = true;
    join()
});

socket.on("disconnect", () => {
    state.connected = false;
});

socket.on("connect_error", (err) => {
    console.warn("[feed socket] connect_error", err?.message, "transport:", socket.io?.engine?.transport?.name);
});

const join = () => {
    socket.emit('live-odds')
    socket.emit('fixture-updates')
}

